import React from 'react'
import AssignTrainer from '../admin/AssignTrainer'

const CoordinatorTrainerAssign = () => {
  return (
  <AssignTrainer/>
  )
}

export default CoordinatorTrainerAssign